import { render, staticRenderFns } from "./packConfig.vue?vue&type=template&id=67b2ceda&scoped=true"
import script from "./packConfig.vue?vue&type=script&lang=js"
export * from "./packConfig.vue?vue&type=script&lang=js"
import style0 from "./packConfig.vue?vue&type=style&index=0&id=67b2ceda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b2ceda",
  null
  
)

export default component.exports